import { mainnet, polygon } from 'wagmi/chains';

const apiErc20ChainSymbols = ['ETH', 'POLYGON'] as const;

export const wagmiChainSymbols = [
  mainnet.nativeCurrency.symbol,
  polygon.nativeCurrency.symbol,
];

type apiErc20ChainSymbol = (typeof apiErc20ChainSymbols)[number];
export type WagmiChainSymbol = (typeof wagmiChainSymbols)[number];

const symbolMap: Record<WagmiChainSymbol, apiErc20ChainSymbol> = {
  ETH: 'ETH',
  POL: 'POLYGON',
} as const;

const fromWagmiSymbol = (symbol: WagmiChainSymbol) => {
  return symbolMap[symbol];
};

const toWagmiSymbol = (symbol: apiErc20ChainSymbol) =>
  Object.keys(symbolMap).find((key) =>
    symbolMap[key as keyof typeof symbolMap].includes(symbol)
  ) as WagmiChainSymbol | undefined;

export const apiChainSymbol = {
  fromWagmiSymbol,
  toWagmiSymbol,
};
